import React from 'react';

export const PhotoInfo = ({ photo, categoryName, onBook }) => (
  <div className="lg:sticky lg:top-32" data-testid="photo-info">
    <h1 className="sr-only">{photo.title} – {categoryName} photography in Dubai by Elina K.</h1>
    <button onClick={onBook} className="hero-cta w-full" style={{ marginTop: 0 }} data-testid="photo-book-btn">
      Book {categoryName} Session
    </button>
  </div>
);
